import { SkeletonBlock } from '@/src/components/ui/SkeletonBlock';
import { cx } from '@/styled-system/css';
import type { ReviewSourceId } from './ReviewsSourceIcon';
import * as styles from './reviewsSkeleton.styles';
import * as redditStyles from './redditReviews.styles';

export function ReviewsPanelSkeleton({
  source = 'web',
  message = 'Loading reviews',
}: {
  source?: ReviewSourceId;
  message?: string;
}) {
  return (
    <div className={cx(styles.content, source === 'google' ? styles.google : styles.panel)} aria-busy="true">
      <output className={styles.visuallyHidden}>{message}</output>
      <div className={styles.content} aria-hidden="true">
        {source === 'reddit' ? (
          <SkeletonBlock className={styles.line} />
        ) : (
          <div className={styles.row}>
            <SkeletonBlock className={styles.rating} />
            <SkeletonBlock className={styles.shortLine} />
          </div>
        )}
        {source !== 'reddit' && <SkeletonBlock className={styles.title} />}
        <div
          className={source === 'reddit' ? redditStyles.topics : source === 'web' ? styles.webCards : styles.content}
        >
          {(source === 'reddit' ? [0, 1, 2, 3, 4] : source === 'web' ? [0, 1, 2, 3] : [0, 1]).map((index) => (
            <div className={styles.card} key={index}>
              <SkeletonBlock className={styles.shortLine} />
              <SkeletonBlock className={styles.line} />
              <SkeletonBlock className={styles.line} />
              {source !== 'reddit' && <SkeletonBlock className={styles.shortLine} />}
            </div>
          ))}
        </div>
        {source === 'web' && <SkeletonBlock className={styles.tabs} radius="md" />}
      </div>
    </div>
  );
}

export function ReviewsLoadingContent() {
  return (
    <>
      <SkeletonBlock className={styles.tabs} radius="md" />
      <ReviewsPanelSkeleton source="google" />
    </>
  );
}

export function ReviewsEntrySkeleton() {
  return (
    <div className={styles.entry} aria-busy="true">
      <output className={styles.visuallyHidden}>Loading reviews</output>
      <SkeletonBlock className={styles.title} />
    </div>
  );
}
